import { useQuery } from '@tanstack/react-query';
import { Link } from 'react-router-dom';
import { errorMessage } from '../../lib/api';
import { brl, dmy, statusLabel, salesApi } from '../../lib/sales';

/**
 * "Propostas de venda" na ficha do lead (V4): as propostas que este lead negociou. O lead
 * é quem negociou, não precisa ser beneficiário (Q11). Cada vendedor vê só as próprias
 * propostas — a lista já vem no escopo de vendas.
 */
export function LeadProposalsSection({ leadId }: { leadId: string }) {
  const query = useQuery({
    queryKey: ['sales', 'by-lead', leadId],
    queryFn: () => salesApi.listByLead(leadId),
  });

  if (query.isLoading) return <p className="text-sm text-slate-500">Carregando…</p>;
  if (query.error) {
    return (
      <p className="text-sm text-red-600">
        {errorMessage(query.error, 'Não consegui carregar')}
      </p>
    );
  }
  const proposals = query.data ?? [];
  return (
    <div className="space-y-3">
      {proposals.length === 0 && (
        <p className="text-sm text-slate-500">
          Nenhuma proposta sua ligada a este lead. Num negócio do lead, use “Proposta de venda”.
        </p>
      )}
      {proposals.map((proposal) => {
        const total = proposal.beneficiaries.reduce((sum, item) => sum + item.monthlyCents, 0);
        return (
          <div
            key={proposal.id}
            className="rounded-lg border border-slate-200 bg-white p-3 text-sm"
          >
            <div className="flex flex-wrap items-center gap-2">
              {proposal.requestNumber && (
                <span className="rounded bg-slate-100 px-2 py-0.5 font-mono text-xs">
                  {proposal.requestNumber}
                </span>
              )}
              <span className="font-medium text-slate-900">{proposal.company}</span>
              <span className="rounded-full bg-slate-100 px-2 py-0.5 text-xs text-slate-600">
                {statusLabel(proposal.status)}
              </span>
            </div>
            <p className="mt-1 text-xs text-slate-500">
              {proposal.operator} · vigência {dmy(proposal.effectiveDate)} · {proposal.lives}{' '}
              {proposal.lives === 1 ? 'vida' : 'vidas'} · {brl(total)}
              {proposal.seller ? ` · ${proposal.seller.name}` : ''}
            </p>
            <p className="mt-1 text-xs text-slate-500">
              Beneficiários: {proposal.beneficiaries.map((item) => item.name).join(', ') || '—'}
            </p>
          </div>
        );
      })}
      <Link to="/vendas" className="inline-block text-sm text-slate-600 underline">
        Abrir a tela de Vendas
      </Link>
    </div>
  );
}
